<template>
  <!-- cod. tag -->
  <div class="md:col-span-1">
    <BaseInput
      type="text"
      name="itensForm.values.cod_tag"
      v-model="store.itensForm.values.cod_tag"
      :info="'Cod. / Tag'"
      label="Cod. / Tag"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton @click="store.itensForm.values.cod_tag = undefined" />
      </template>
    </BaseInput>
  </div>

  <!-- estado acionador -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Estado do acionador
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.estado_caixa"
          :initialValue="store.itensForm.values.estado_caixa"
          @selected-data="(val) => (store.itensForm.values.estado_caixa = val)"
        />
      </div>
    </div>
  </div>

  <!-- estado obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.estado_caixa?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.estado_caixa_descript"
        :info="'Inadequação do acionador'"
        label="Não funcional, danificado..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.estado_caixa_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- obstru -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Livre de obstrução
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.obstru"
          :initialValue="store.itensForm.values.obstru"
          @selected-data="(val) => (store.itensForm.values.obstru = val)"
        />
      </div>
    </div>
  </div>

  <!-- obstru desc -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.obstru?.value == 'nao'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.obstru_descript"
        :info="'Obstrução'"
        label="Não visivel, item escondido..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.obstru_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- led verde -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Funcionamento da led
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.leds"
          :initialValue="store.itensForm.values.led_verde"
          @selected-data="(val) => (store.itensForm.values.led_verde = val)"
        />
      </div>
    </div>
  </div>

  <!-- led -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.led_verde?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.led_verde_descript"
        :info="'Inadequação da led'"
        label="Nao funcional, danificada..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.led_verde_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- vidro -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Proteção acrílica
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.leds"
          :initialValue="store.itensForm.values.vidro"
          @selected-data="(val) => (store.itensForm.values.vidro = val)"
        />
      </div>
    </div>
  </div>

  <!-- vidro obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.vidro?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.vidro_descript"
        :info="'Estado da proteção acrílica'"
        label="Sem proteção, danificada..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.vidro_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- Comunicação entre acionador e central -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Comunicação acionador e central
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.comunicacao"
          :initialValue="store.itensForm.values.comunicacao"
          @selected-data="(val) => (store.itensForm.values.comunicacao = val)"
        />
      </div>
    </div>
  </div>

  <!-- comunicação obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.comunicacao?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.comunicacao_descript"
        :info="'Status da comunicação'"
        label="Sem comunicação, danificada..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.comunicacao_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- funcionamento -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Funcionamento do acionador
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.funcionamento"
          :initialValue="store.itensForm.values.funcionamento"
          @selected-data="(val) => (store.itensForm.values.funcionamento = val)"
        />
      </div>
    </div>
  </div>

  <!-- func. obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.funcionamento?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.funcionamento"
        v-model="store.itensForm.values.funcionamento_descript"
        :info="'Inadequação funcional'"
        label="Mau funcionamento, danificado..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.funcionamento_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- funcionamento som -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Funcionamento audio visual
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="siren.funcionamento"
          :initialValue="store.itensForm.values.funcionamento_som"
          @selected-data="(val) => (store.itensForm.values.funcionamento_som = val)"
        />
      </div>
    </div>
  </div>

  <!-- funcio. obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.funcionamento_som?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.funcionamento"
        v-model="store.itensForm.values.funcionamento_som_descript"
        :info="'Inadequação audio visual'"
        label="Apenas leds, apenas som..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.funcionamento_som_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

</template>

<script setup>
import CleanInputButton from '../../utils/CleanInputButton.vue'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import { dataExtinguisher } from '../../store'
import { siren } from '../../lookups/form'

const store = dataExtinguisher.state

</script>
